import {InjectionToken} from '@angular/core';
import {GridFilterFieldEntity} from './grid-filter-field-entity';

export const GRID_FILTER_FIELDS = new InjectionToken<Array<GridFilterFieldEntity>>('GRID_FILTER_FIELDS');
